import React from "react";
import "./navbar.css"

class Navbar extends React.Component {
    render() {
        return (
            <nav className="bla">
                <header className="headers">
                    <a href="/" className="brandlogo">
                        <div className="nomlogonav row">
                            <img src="./image/favicon-OGEcontour.png" height='45px' alt="logo" />
                            <p className="column">Hermand Philippe <span>Géomètre Expert</span></p>
                        </div>
                    </a>
                    <input className="menu-btn" type="checkbox" id="menu-btn" />
                    <label className="menu-icon" htmlFor="menu-btn"><span className="navicon"></span></label>
                    <ul className="menu">
                        <li><a href="/recrutement">Recrutement</a></li>
                        <li><a href="/bureau">Nos locaux</a></li>
                        <li><a href="/actualites">Actualité</a></li>
                    </ul>
                </header>
            </nav>
        )
    }
}

export default Navbar;
